module.exports = __webpack_public_path__ + "media/entities/1606-cfed83fc.png";